export default __webpack_public_path__ + "static/media/view-query.19a54ba3.svg";